import { PDF_REPORT_CONTENT } from 'modules/messagingInsights/constants';
import { useTabContext } from 'modules/messagingInsights/context';
import { PDF_REPORT_FORM_FIELD_NAMES } from 'modules/messagingInsights/schema';
import {
  CheckboxFormField,
  InputFormField,
  LocationFormField,
  TimeSeriesFormField,
} from './fields';
import { AudienceFormField } from './fields/AudienceFormField';
import { PageSettings, PageSettingsTitle } from './Styled';

export const PDFReportForm = () => {
  const { showDeviceTab, showLocationTab } = useTabContext();
  const {
    REPORT_DETAILS: { NAME },
    FORM_SETTINGS: { CHART_DISPLAY, LOCATION_REGION, AUDIENCE_SEGMENT, SEGMENT_TIME_FREQUENCY },
    PAGES: { OVERVIEW, CAMPAIGNS, AUDIENCE, TIME_SERIES, LOCATIONS, DEVICES },
  } = PDF_REPORT_FORM_FIELD_NAMES;
  const {
    title,
    fieldLabelName,
    fieldLabelOverview,
    fieldLabelCampaigns,
    fieldLabelAudience,
    fieldLabelTimeSeries,
    fieldLabelLocations,
    fieldLabelDevices,
    fieldDescriptionOverview,
    fieldDescriptionCampaigns,
    fieldDescriptionAudience,
    fieldDescriptionTimeSeries,
    fieldDescriptionLocations,
    fieldDescriptionDevices,
    fieldPlaceholderLocations,
    fieldPlaceholderAudience,
  } = PDF_REPORT_CONTENT;

  return (
    <>
      <InputFormField
        dataTestId="pdf-report-name"
        fieldName={NAME}
        fieldLabel={fieldLabelName}
        autoFocus
      />
      <PageSettings>
        <PageSettingsTitle>{title}</PageSettingsTitle>
        <CheckboxFormField
          dataTestId="overview"
          fieldName={OVERVIEW}
          title={fieldLabelOverview}
          description={fieldDescriptionOverview}
        />
        <CheckboxFormField
          dataTestId="campaigns"
          fieldName={CAMPAIGNS}
          title={fieldLabelCampaigns}
          description={fieldDescriptionCampaigns}
        />
        <CheckboxFormField
          dataTestId="audience"
          fieldName={AUDIENCE}
          title={fieldLabelAudience}
          description={fieldDescriptionAudience}
        >
          <AudienceFormField
            fieldName={AUDIENCE_SEGMENT}
            secondaryFieldName={SEGMENT_TIME_FREQUENCY}
            fieldPlaceholder={fieldPlaceholderAudience}
          />
        </CheckboxFormField>
        <CheckboxFormField
          dataTestId="time-series"
          fieldName={TIME_SERIES}
          title={fieldLabelTimeSeries}
          description={fieldDescriptionTimeSeries}
        >
          <TimeSeriesFormField fieldName={CHART_DISPLAY} />
        </CheckboxFormField>
        {showLocationTab && (
          <CheckboxFormField
            dataTestId="locations"
            fieldName={LOCATIONS}
            title={fieldLabelLocations}
            description={fieldDescriptionLocations}
          >
            <LocationFormField
              fieldName={LOCATION_REGION}
              fieldPlaceholder={fieldPlaceholderLocations}
            />
          </CheckboxFormField>
        )}
        {showDeviceTab && (
          <CheckboxFormField
            dataTestId="devices"
            fieldName={DEVICES}
            title={fieldLabelDevices}
            description={fieldDescriptionDevices}
          />
        )}
      </PageSettings>
    </>
  );
};
